import { createContext, useState } from 'react';

const NotificationsContext = createContext({
    isShowModal: false,
    modalInfo: null,
    showModal: (modalInfo) => { },
    hideModal: () => { },
});

export function NotificationsContextProvider(props) {
    const [isShowModal, setIsShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});

    function showModalHandler(modalInfo) {
        setModalInfo(modalInfo);
        setIsShowModal(true);
    }

    function hideModalHandler() {
        setIsShowModal(false);
    }

    const context = {
        isShowModal: isShowModal,
        modalInfo: modalInfo,
        showModal: showModalHandler,
        hideModal: hideModalHandler,
    };

    return (
        <NotificationsContext.Provider value={context}>
            {props.children}
        </NotificationsContext.Provider>
    );
}

export default NotificationsContext;